import { Injectable } from '@angular/core';

import { Timestamp, arrayUnion, collection, doc, setDoc, count, sum, average, getAggregateFromServer, getFirestore, deleteDoc, getDocs, where, query, documentId, getDoc, updateDoc, getDocFromCache, addDoc, orderBy, increment } from "firebase/firestore";
import moment from 'moment';
import { BehaviorSubject, Observable, defer, from, switchMap } from 'rxjs';
import { ownedCollection, withCurrentOwner } from '../../../utils/firestore-ownership';


@Injectable({
  providedIn: 'root'
})
export class ReitsService {

  private reits!: BehaviorSubject<any[]>;

  constructor() {
    this.reits = new BehaviorSubject<any[]>([])
  }

  public async selectAll(): Promise<void> {
    // console.log('ReitsService', 'selectAll')

    const reits:any[] = []

    // const q = query(collection(getFirestore(), "Stocks"), where("side", "==", 'BUY'), orderBy('side', 'asc'))
    const q = ownedCollection('Reits');
    const allDocs = await getDocs(q)
    allDocs.docs.forEach((d:any, j:any, h:any) => {
      console.log('Doc:', d.id, 'Side:', d.data().side, j)
      const doc = { ...d.data(), id: d.id }
      reits.push(doc)
    })

    this.reits.next(reits)
  }

  getAll(): Observable<any[]> {
    console.log('ReitsService', 'getAll')

    return defer(() => from(this.selectAll()).pipe(switchMap(() => this.reits.asObservable())));
  }
  
  async addItem(e:any):Promise<void> {
    console.log('ReitsService', 'addItem', e)

    await addDoc(collection(getFirestore(), 'Reits'), { ...withCurrentOwner(e), created_on: Timestamp.now(), modified_on: Timestamp.now() });
    // this.reits.next([e, ...this.reits.value])
    await this.selectAll()
  }

  async delete(e:any):Promise<void>{
    console.log('ReitsService', 'delete', e.id)

    await deleteDoc(doc(getFirestore(), 'Reits', e.id));
    await this.selectAll();
  }

  async modify(e:any):Promise<void>{
    console.log('ReitsService', 'modify', e.id)

    await updateDoc(doc(getFirestore(), 'Reits', e.id), { ...withCurrentOwner(e), modified_on: Timestamp.now() });
    await this.selectAll();
  }

  async updateAttach(e: any, path: string, name: string) {
    console.log('ReitsService', 'updateAttach', e.id)
    
    await updateDoc(doc(getFirestore(), "Reits", e.id), {
      attach: increment(1),
      attachments: arrayUnion({ path, name, createdOn: Timestamp.now() })
    })
    .then(() => {
      console.log('ReitsService', 'updateAttach', e.id, 'UPDATED')
    })
    
  }

}
